module.exports = __webpack_public_path__ + "static/media/display-3.cef55ee6.png";